export default __webpack_public_path__ + "static/media/Logo-blue.e9a21c6e.png";